<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3 11C3 9.89543 3.89543 9 5 9H11C12.1046 9 13 9.89543 13 11V14H3V11Z"
    fill="currentColor"
  />
  <rect
    x="5"
    y="2"
    width="6"
    height="6"
    rx="3"
    fill="currentColor"
  />
</svg>
